import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import { isEqual } from 'lodash';
import { Loader, Tooltip } from '@components/common';

class Action extends Component {
	shouldComponentUpdate = ({
		url,
		disabled,
		active,
		displayName,
		description,
		loading,
		count,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(url, lastProps.url)
			|| !isEqual(disabled, lastProps.disabled)
			|| !isEqual(active, lastProps.active)
			|| !isEqual(displayName, lastProps.displayName)
			|| !isEqual(description, lastProps.description)
			|| !isEqual(loading, lastProps.loading)
			|| !isEqual(count, lastProps.count)
		);
	}

	render() {
		const {
			url,
			onClick,
			disabled,
			active,
			displayName,
			description,
			loading,
			count,
			linkComponent : LinkComponent,
		} = this.props;

		return (
			<LinkComponent
				to={url}
				className={classNames({ active, disabled, 'recently-paid' : displayName === 'Recently Paid' })}
				onClick={onClick}
			>
				<span>{ displayName }</span>
				<If condition={displayName !== 'Recently Paid'}>
					<Tooltip content={description}>
						<i
							className={classNames('rkf help-icon', {
								'rkf-question-solid' : active,
								'rkf-question-o'     : !active,
							})}
						/>
					</Tooltip>
				</If>
				<If condition={displayName !== 'Recently Paid'}>
					<div className="number-container">
						<Choose>
							<When condition={!loading}>
								<span className="number">{ count }</span>
							</When>
							<Otherwise>
								<div className="loader-wrapper">
									<Loader
										active={loading}
										size="small"
										spinnerOnly
									/>
								</div>
							</Otherwise>
						</Choose>
					</div>
				</If>
			</LinkComponent>
		);
	}
}

Action.propTypes = {
	url           : PropTypes.string.isRequired,
	active        : PropTypes.bool.isRequired,
	displayName   : PropTypes.string.isRequired,
	description   : PropTypes.string.isRequired,
	count         : PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	loading       : PropTypes.bool,
	disabled      : PropTypes.bool,
	linkComponent : PropTypes.func,
	onClick       : PropTypes.func,
};

Action.defaultProps = {
	count         : undefined,
	linkComponent : Link,
	onClick       : () => {},
	disabled      : false,
	loading       : false,
};

export default Action;
